import { connect } from "react-redux";
import { parse } from "query-string";
import { sessionConnect, sessionTokenLogin } from "../actions/session";
import React from "react";
import { setAuthenticationTokenParamPresent } from "../actions/deposit";

class Connection extends React.PureComponent {
  constructor(props) {
    super(props);

    var {
      setAuthenticationTokenParamPresent: onSetAuthenticationTokenParamPresent,
      sessionConnect: onSessionConnect,
      sessionTokenLogin: onSessionTokenLogin
    } = props;
    const query = parse(window.location.search);

    var authenticationToken = query.authentication_token || query.token; // eslint-disable-line camelcase
    if (authenticationToken) {
      onSetAuthenticationTokenParamPresent(true);
      onSessionTokenLogin(authenticationToken, true);
    } else {
      onSessionConnect();
    }
  }

  render() {
    var { children } = this.props;
    return (
      <div>
        {children}
      </div>
    );
  }
}

function select() {
  return {};
}

export default connect(select, { sessionConnect, sessionTokenLogin, setAuthenticationTokenParamPresent })(Connection);
